// removed by extract-text-webpack-plugin
module.exports = {"table":"wwi2KLt3Q0iMIRvPYGBik"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PersonalInvoiceManager/PersonalInvoiceManager.scss
 ** module id = 1089
 ** module chunks = 0
 **/